"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAndSendV0Transaction = void 0;
const constants_1 = require("../constants");
const anchor_1 = require("@project-serum/anchor");
const STANDART_LOOKUP_TABLE = new anchor_1.web3.PublicKey(constants_1.LOOKUP_TABLE);
//? Sequence means that transactions will be signed at once, but will be sent in a sequence by chunks.
//? F.e. txnsAndSigners: [[x, x, x], [y, y, y], [z, z, z]]. Sign all txns at once. But first send [x, x, x], wait for confirmation, send [y, y, y] wait for confirmation, send [z, z, z]
//? It needs when transactions from next chunk are related to transactions from previos chunk
const createAndSendV0Transaction = ({ lookupTablePublicKeys, v0InstructionsAndSigners, connection, wallet, commitment = 'confirmed', onBeforeApprove, skipPreflight, onAfterSend, onSuccess, onError, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { blockhash, lastValidBlockHeight } = yield connection.getLatestBlockhash();
        //? Filter empty arrays from two-dimensional array
        // const txnsAndSignersFiltered = txnsAndSigners.filter((arr) => !!arr.length);
        // onBeforeApprove?.();
        const addressesPerTxn = 20;
        const supposedBigIntDeactivationSlot = BigInt('18446744073518870550');
        const slotCorrection = 2;
        console.log('slotCorrection: ', slotCorrection);
        const lastSlot = (yield connection.getSlot()) + slotCorrection;
        const v0Transactions = yield Promise.all(v0InstructionsAndSigners.map((ixAndSigner) => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            console.log('ixAndSigner.lookupTablePublicKeys: ', lookupTablePublicKeys);
            const lookupTablesCalls = lookupTablePublicKeys.map((tablePubkey) => __awaiter(void 0, void 0, void 0, function* () { return (yield connection.getAddressLookupTable(tablePubkey)).value; }));
            const lookupTables = yield Promise.all(lookupTablesCalls);
            // const lookupTables: web3.AddressLookupTableAccount[] = ixAndSigner.lookupTablePublicKeys.map(
            //   (tableData) =>
            //     new web3.AddressLookupTableAccount({
            //       key: tableData.tablePubkey,
            //       state: {
            //         addresses: tableData.addresses,
            //         authority: wallet.publicKey,
            //         deactivationSlot: supposedBigIntDeactivationSlot + BigInt(lastSlot),
            //         lastExtendedSlot: lastSlot,
            //         lastExtendedSlotStartIndex: Math.floor(tableData.addresses.length / addressesPerTxn) * addressesPerTxn,
            //       },
            //     }),
            // );
            // (await Promise.all(
            //   ixAndSigner.lookupTablePublicKeys.map(
            //     async (lookupTablePublicKey) =>
            //       (
            //         await connection.getAddressLookupTable(
            //           new PublicKey(lookupTablePublicKey.tablePubkey),
            //         )
            //       ).value,
            //   ),
            // )).map(tableAccount => ({
            //   ...tableAccount, state: {
            //     ...tableAccount.state,
            //     lastExtendedSlot: lastSlot,
            //     deactivationSlot: supposedBigIntDeactivationSlot + BigInt(tableAccount.state.lastExtendedSlot)
            //   }
            // }));
            console.log('INITIALIZED LOOKUP TABLES SLOTS: ', lookupTables[0].state);
            console.log('Authority: ', (_b = (_a = lookupTables[0].state) === null || _a === void 0 ? void 0 : _a.authority) === null || _b === void 0 ? void 0 : _b.toBase58());
            const transactionsMessageV0 = new anchor_1.web3.VersionedTransaction(new anchor_1.web3.TransactionMessage({
                payerKey: wallet.publicKey,
                recentBlockhash: blockhash,
                instructions: ixAndSigner.instructions,
            }).compileToV0Message([...lookupTables]));
            transactionsMessageV0.sign([...(ixAndSigner.signers || [])]);
            return transactionsMessageV0;
        })));
        // v0InstructionsAndSigners.map(ixAndSigners => ixAndSigners.lookupTablePublicKeys).flat().map(lookupTableData =>
        // ([
        //   AddressLookupTableProgram.deactivateLookupTable({
        //     authority: wallet.publicKey,
        //     lookupTable: lookupTableData.tablePubkey
        //   }),
        //   AddressLookupTableProgram.closeLookupTable({
        //     authority: wallet.publicKey,
        //     recipient: wallet.publicKey,
        //     lookupTable: lookupTableData.tablePubkey
        //   })])).map(instructions => new Transaction().add(instructions[0], instructions[1])).map(transaction => {
        //     transaction.recentBlockhash = blockhash;
        //     transaction.feePayer = wallet.publicKey;
        //     return transaction;
        //   });
        // const closeLook
        // AddressLookupTableProgram.closeLookupTable({
        //   authority: wallet.publicKey,
        //   lookupTable:
        // });
        const v0MainAndCloseTableTxns = [...v0Transactions];
        const transactionsFlatArr = [...v0MainAndCloseTableTxns];
        const signedTransactions = yield wallet.signAllTransactions([...transactionsFlatArr]);
        const txnsAndSignersWithV0Txns = [v0MainAndCloseTableTxns];
        console.log('goes here to sending?');
        console.log('txnsAndSignersWithV0Txns: ', txnsAndSignersWithV0Txns);
        console.log('signedTransactions: ', signedTransactions);
        let currentTxIndex = 0;
        for (let i = 0; i < txnsAndSignersWithV0Txns.length; i++) {
            if (txnsAndSignersWithV0Txns[i].length === 0)
                continue;
            for (let r = 0; r < txnsAndSignersWithV0Txns[i].length; r++) {
                console.log('currentTxIndex: ', currentTxIndex);
                const txn = signedTransactions[currentTxIndex];
                if (!txn)
                    continue;
                // lastSlot = await connection.getSlot();
                const tx = yield connection.sendRawTransaction(txn.serialize(), {
                    skipPreflight,
                    preflightCommitment: commitment,
                });
                currentTxIndex += 1;
                // console.log("MinContextSlot: ", txn.minNonceContextSlot)
            }
            if (txnsAndSignersWithV0Txns[i].length > 0)
                yield new Promise((r) => setTimeout(r, 8000));
        }
        // const signedTransactionsV0 = await wallet.signAllTransactions(
        //   v0Transactions,
        // );
        // const txnSignatures = await Promise.all(
        //   signedTransactionsV0.map((signedTransaction) =>
        //     connection.sendTransaction(signedTransaction, { maxRetries: 5 }),
        //   ),
        // );
        //   );
        onAfterSend === null || onAfterSend === void 0 ? void 0 : onAfterSend();
        // const actualTableAccounts =
        //   (await Promise.all(
        //     v0InstructionsAndSigners.map(r => r.lookupTablePublicKeys).flat().map(
        //       async (lookupTablePublicKey) =>
        //         (
        //           await connection.getAddressLookupTable(
        //             new PublicKey(lookupTablePublicKey.tablePubkey),
        //           )
        //         ).value,
        //     ),
        //   ));
        // console.log('actualTableAccounts: ', actualTableAccounts[0])
        // console.log('actualTableAccounts: ', JSON.stringify(actualTableAccounts, null, 2))
        // await new Promise((r) => setTimeout(r, 7000));
        // //? Can't cover this shit with types properly
        // const resultsContainErr = results
        //   .map((res) => !!(res as any)?.value?.value?.err)
        //   .find(Boolean);
        // if (resultsContainErr) {
        //   throw new Error('Transaction contains error');
        // }
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        return true;
    }
    catch (error) {
        onError === null || onError === void 0 ? void 0 : onError(error);
        return false;
    }
});
exports.createAndSendV0Transaction = createAndSendV0Transaction;
